<app-title-bar
  [tagNameList]="tagNameList"
  [title]="title"
  [showBackButton]="prevPage.hasHistory()"
  (clickBack)="onClickBack()"
></app-title-bar>
<app-retool-iframe
[embeddedURLRequest]="embeddedURLRequest"
></app-retool-iframe>
